import { render, staticRenderFns } from "./PrincipalsForm.vue?vue&type=template&id=e0670a40&"
import script from "./PrincipalsForm.vue?vue&type=script&lang=js&"
export * from "./PrincipalsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports